import React from 'react';
import './Research.css';

const Research = () => {
  const research = [
    {
      icon: 'fa-car-battery',
      title: 'Multi-Objective EV Routing using NSGA-II',
      period: 'Jan 2025 - Present',
      description: 'Researching optimization for Electric Vehicle routing using NSGA-II to minimize travel distance and energy use. Developed a simulation environment to evaluate Pareto-optimal routes using spatial and charging station data.',
      topics: ['Optimization', 'NSGA-II', 'EV Routing', 'Pareto Optimization']
    },
    {
      icon: 'fa-hands',
      title: 'Indian Sign Language (ISL) to English Translation',
      period: 'Jan 2025 - Present',
      description: 'Co-authored a paper on deep learning for gesture recognition and NLP for ISL translation. Submitted to IISc 4AM Conference 2025.',
      topics: ['Deep Learning', 'NLP', 'Gesture Recognition', 'Computer Vision']
    }
  ];

  return (
    <section id="research" className="research">
      <div className="container">
        <h1 className="section-title">Research</h1>
        <div className="research-grid">
          {research.map((item, index) => (
            <div key={index} className="research-card">
              <div className="research-header">
                {item.logo ? (
                  <img src={item.logo} alt={item.title} />
                ) : (
                  <div className="research-icon">
                    <i className={`fas ${item.icon}`}></i>
                  </div>
                )}
                <div className="research-period">{item.period}</div>
              </div>
              <h2>{item.title}</h2>
              <p className="description">{item.description}</p>
              <div className="topics">
                {item.topics.map((topic, idx) => (
                  <span key={idx} className="topic-tag">{topic}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Research;
